module.exports = __webpack_public_path__ + "img/AMEX_60x36.ecca7865.jpg";